import { defineStore } from 'pinia'
import { ref } from 'vue'
import { UserLoginAPI } from '@/apis/Users/login'
import { GetUserInfoAPI } from '@/apis/Users/personal'
import { PhoneLoginAPI } from '@/apis/Users/login'

export const useLoginStore = defineStore('user', () => {
  const form = ref({})
  const token = ref(localStorage.getItem('userToken') || null)
  const message = ref('')

  const login = async (credentials) => {
    let res;
    if (credentials.email) {
      // 账户密码登录
      res = await UserLoginAPI(credentials);
    } else {
      // 手机号登录
      res = await PhoneLoginAPI(credentials);
    }
    
    if (res.data.code === 0) {
      form.value = res.data;
      token.value = res.data.data;
      console.log("token.value", token.value);
      const role = await GetUserInfoAPI();
      console.log("role", role.data.data.role);
      localStorage.setItem('userId', role.data.data.userId);
      localStorage.setItem('companyId', role.data.data.companyId);
      localStorage.setItem('userInfo', JSON.stringify(role.data.data.role));
      localStorage.setItem('userToken', res.data.data);
      console.log('qualificationApprovedOrNot',role.data.data.qualificationApprovedOrNot);
      
      localStorage.setItem('qualificationApprovedOrNot',role.data.data.qualificationApprovedOrNot)
      return res.data.code;
    }
    return res.data.code;
  }

  const setToken = (newToken) => {
    token.value = newToken
  }

  const setMessage = (msg) => {
    message.value = msg
    if (msg === '登录凭证失效') {
      removeUserInfo()
    }
  }

  const removeUserInfo = () => {
    token.value = null
    message.value = ''
    localStorage.removeItem('userToken')
  }

  return {
    token,
    form,
    message,
    login,
    setToken,
    setMessage,
    removeUserInfo,
  }
}, {
  persist: true
})